<template>
    <div class="login">
        <el-row style="width: 100%; height: 80px; background: #12c287">
            <el-col :span="5" style="margin-top: 16px">
                <img src="/static/img/logo.png" alt="" />
            </el-col>
        </el-row>
        <el-row style="margin-top: 200px; margin-left: 360px">
            <el-col :span="5">
                <img src="/static/images/切图版本2-1.png" alt="" />
            </el-col>
            <el-col :span="5" style="margin-left: 275px">
                <div class="welcome1" style="width: 600px; height: 600px; background: #fff">
                    <el-form :class="[
                        msgIsShow
                            ? 'register-form-right'
                            : 'register-form-center',
                    ]" :model="ruleForm" ref="ruleForm">
                        <div style="margin-top: 110px">
                            <p style="
                                    text-align: left;
                                    color: #12c287;
                                    font-size: 24px;
                                ">
                                账号密码登录
                            </p>
                            <div style="
                                    width: 144px;
                                    height: 2px;
                                    background: #12c287;
                                    margin-top: -12px;
                                "></div>
                            <div class="tipMsg">
                                <span v-show="isShowTipMsg">{{ tipMsg }}</span>
                            </div>
                        </div>

                        <el-form-item label="" prop="username">
                            <el-input class="login-input" prefix-icon="el-icon-s-custom" placeholder="请输入邮箱账号"
                                v-model="ruleForm.username"></el-input>
                        </el-form-item>

                        <el-form-item prop="password">
                            <el-input class="login-input" prefix-icon="el-icon-lock" placeholder="密码"
                                v-model="ruleForm.password" show-password></el-input>
                        </el-form-item>

                        <div style="margin-top: 48px">
                            <el-button class="loginButton" type="primary" @click="submit">登录</el-button>
                        </div>

                        <div style="margin-top: 16px">
                            <el-row>
                                <el-col :span="12">
                                    <el-button class="loginNagtiveButton" style="width: 100%; text-align: left" type="text"
                                        @click="forget">忘记密码？</el-button>
                                </el-col>
                                <el-col :span="12">
                                    <el-button class="loginNagtiveButton" style="
                                            width: 100%;
                                            text-align: right;
                                            color: white;
                                        " type="text" @click="toregin">注册新用户</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </el-form>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import axios from 'axios'
import { fullScreenStartLoading, fullScreenEndLoading } from '@/js/loading.js'
import { popErrMsg } from '@/js/hgisUtil.js'

export default {
    name: 'Login',
    data() {
        return {
            LoginForm: {
                username: '',
                password: '',
            },
            logining: false,
            rule: {
                username: [
                    {
                        required: true,
                        max: 144,
                        min: 4,
                        message: '用户名不能为空，长度为4-14位.',
                        trigger: 'blur',
                    },
                ],
                password: [
                    {
                        required: true,
                        message: '密码不能为空',
                        trigger: 'blur',
                    },
                ],
            },
            userToken: '',
            isShowTipMsg: false,
            screenWidth: document.body.clientWidth,

            // 是否显示提示信息
            isLockBtnLogin: true,
            tipMsg: '请您输入用户名或密码！',

            ruleForm: {
                username: '',
                password: '',

                // 用户是否输入用户名
                isUserName: false,
            },
            msgIsShow: true,
        }
    },
    mounted() {
        const that = this
        window.onresize = () => {
            return (() => {
                window.screenWidth = document.body.clientWidth
                window.screenHeight = document.body.clientHeight
                that.screenWidth = window.screenWidth
            })()
        }
    },
    watch: {
        screenWidth(val) {
            if (!this.timer) {
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                this.screenWidth = val // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
                if (this.screenWidth < 960) {
                    this.msgIsShow = false
                } else {
                    this.msgIsShow = true
                }
                this.timer = true
                let that = this
                setTimeout(function () {
                    that.timer = false
                }, 400)
            }
        },
    },
    methods: {
        //判断是否是管理员用户
        isAdminAccount() {
            let self = this
            axios({
                url: $webConfig.V3.backendAPI + 'isAdminAccount',
                method: 'post',
                data: JSON.stringify({
                    mail: this.ruleForm.username,
                }),
            }).then((res) => {
                if (res.data.role == '管理员') {
                    self.$cookie.set(
                        'V3loginRole',
                        '管理员'
                    )
                    self.$store.state.V3loginRole = '管理员'
                } else if (res.data.role == '普通用户') {
                    self.$cookie.set(
                        'V3loginRole',
                        '普通用户'
                    )
                    self.$store.state.V3loginRole = '普通用户'
                    
                }

                self.$router.push({
                    path: '/',
                })

            })
        },
        submit() {
            if (this.ruleForm.username == '') {
                this.isShowTipMsg = true
                this.tipMsg = '请输入邮箱账号！'
            } else if (this.ruleForm.password == '') {
                this.isShowTipMsg = true
                this.tipMsg = '请输入密码！'
            } else if (
                this.ruleForm.userName != '' &&
                this.ruleForm.password != ''
            ) {
                if (this.isLockBtnLogin == true) {
                    this.isShowTipMsg = false

                    let url = $webConfig.V3.backendAPI + 'login'
                    let info = {
                        mail: this.ruleForm.username,
                        password: this.ruleForm.password,
                    }
                    let self = this
                    const axioInstance = axios.create()
                    // 请求拦截器
                    axioInstance.interceptors.request.use(
                        (config) => {
                            fullScreenStartLoading()
                            return config
                        },
                        (error) => {
                            Promise.reject(error)
                        }
                    )
                    // 响应拦截器
                    axioInstance.interceptors.response.use(
                        (response) => {
                            debugger
                            fullScreenEndLoading()
                            return response
                        },
                        (error) => {
                            fullScreenEndLoading()
                            return Promise.reject(error)
                        }
                    )
                    axioInstance
                        .post(url, JSON.stringify(info))
                        .then((res) => {
                            if (res.data.message == '登录成功') {
                                // 记录用户名和登录状态 V3版本
                                self.$cookie.set('mail', self.ruleForm.username)
                                self.$cookie.set('isLogin', 'success') // 设置cookie,默认过期时间单位是1d(1天)
                                self.$cookie.set(
                                    'username',
                                    self.ruleForm.username
                                )
                                self.$store.state.V3mail =
                                    self.ruleForm.username
                                self.$store.state.V3loginState = true

                                self.$store.state.userName =
                                    self.ruleForm.username
                                self.$store.state.isLoginSuccess = true

                                self.isAdminAccount()

                            } else {
                                self.isShowTipMsg = true
                                self.tipMsg = res.data.message
                            }
                        })
                        .catch(function (err) {
                            popErrMsg(
                                self,
                                err.response.status,
                                err.response.statusText
                            )
                        })

                    this.isLockBtnLogin = false
                    setTimeout(() => {
                        this.isLockBtnLogin = true
                    }, 3000)
                } else {
                    //关闭当前所有实例
                    this.$message.closeAll()
                    this.$message({
                        message: '请勿在3秒内重复点击！',
                        type: 'error',
                    })
                    return
                }
            }
        },
        reset() {
            this.$refs.LoginForm.resetFields()
        },
        toregin() {
            this.$router.push('/register')
        },
        forget() {
            this.$router.push('/forget')
        },
    },
}
</script>

<style scoped>
.login-form {
    margin: 20px auto;
    width: 310px;
    background: #fff;
    box-shadow: 0 0 35px #b4bccc;
    padding: 45px 30px 0 30px;
    border-radius: 25px;
}

.submitBtn {
    width: 45%;
}

.to {
    color: #67c23a;
    cursor: pointer;
    float: right;
}

.loginNagtiveButton {
    color: #12c287 !important;
    font-size: 16px !important;
    line-height: 22px;
    font-weight: 400;
}

.loginNagtiveButton:hover {
    font-weight: 600 !important;
    color: #12c287 !important;
}

@media screen and (max-height: 610px) {
    .welcome {
        background: url(/static/img/地理调查表背景.png) no-repeat center;
        background-size: 100% 100%;
        width: 830px;
        height: 375px;
        position: relative;
        top: 20%;
        left: 13%;
    }
}

@media screen and (min-height: 610px) {
    .welcome {
        background: url(/static/img/地理调查表背景.png) no-repeat center;
        background-size: 100% 100%;
        width: 73%;
        height: 61%;
        position: relative;
        top: 20%;
        left: 13%;
    }
}

.login-input>>>.el-input-group__prepend {
    padding: 0 0.8rem !important;
    font-size: 20px !important;
}

.login-input>>>.el-input__inner {
    height: 60px !important;
    font-size: 20px !important;
    background: rgba(255, 255, 255, 0.1) !important;
    border: 1px solid #e8e8e8 !important;
    border-radius: 0 !important;
    color: black !important;
    padding-left: 45px;
}

.login-input>>>.el-input__inner:hover {
    border: 1px solid #12c287 !important;
}

.login-input>>>.el-input__inner:focus {
    border: 1px solid #12c287 !important;
    color: black !important;
}

/* .login-input >>> .el-input__inner::placeholder {
    
} */

.register-form-right>>>.el-form-item__error {
    display: none;
}

.register-form-right>>>.el-form-item__label:before {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/V3/Login.vue